import { OrderPosition } from './OrderPosition';
import { Invoice } from './invoice';

export class Order {
  id: string;

  orderGroupId: string;
  orderNumber: number;
  orderDateTime: Date;
  applicationUserProfileId: string;
  userName: string;

  creatorCustomerId: string;
  creatorCustomerNumber: number;
  creatorCustomerFullName: string;
  creatorCustomerFirstName: string;
  creatorCustomerMiddleName: string;
  creatorCustomerLastName: string;
  creatorCustomerCompanyName: string;
  creatorCustomerStreet: string;
  creatorCustomerCity: string;
  creatorCustomerZIP: string;
  creatorCustomerCountry: string;
  creatorCustomerStateOrRegion: string;
  creatorCustomerVatRegNo: string;
  creatorCustomerEmail: string;
  creatorCustomerInternet: string;
  creatorCustomerPhone: string;
  creatorCustomerFax: string;
  creatorCustomerDescription: string;
  creatorCustomerTaxId: string;

  buyerCustomerId: string;
  buyerCustomerNumber: number;
  buyerCustomerFullName: string;
  buyerCustomerFirstName: string;
  buyerCustomerMiddleName: string;
  buyerCustomerLastName: string;
  buyerCustomerCompanyName: string;
  buyerCustomerStreet: string;
  buyerCustomerCity: string;
  // The wire name: Bff's OrderModel declares BuyerCustomerZip, while the creator's is
  // CreatorCustomerZIP. This field was `buyerCustomerZIP` and so always undefined (#205).
  buyerCustomerZip: string;
  buyerCustomerCountry: string;
  buyerCustomerStateOrRegion: string;
  buyerCustomerVatRegNo: string;
  buyerCustomerEmail: string;
  buyerCustomerInternet: string;
  buyerCustomerPhone: string;
  buyerCustomerFax: string;
  buyerCustomerDescription: string;
  buyerCustomerTaxId: string;

  orderPositions: OrderPosition[] = [];
  netPrice: number;
  vatAmount: number;
  grossPrice: number;
  // Backend #525: uppercase ISO 4217 currency of all the amounts (snapshot; carried, never converted).
  currency: string = 'EUR';
  discountedGrossPrice: number;
  discount: number;
  status: number;
  invoiceType: number;
  isReadyForInvoice: boolean;
  invoiceId: string;
  invoices: Invoice[] = [];
  // #205: when the order's receipt was last printed — set by `PUT order/print/{id}`. Any value
  // means the next print is a reprint, which the receipt marks as a copy.
  lastPrintDateTime?: Date;

  public static isInvoiced(order: Order): boolean {
    return order?.invoices?.findIndex((i) => !i.isArchived && !i.cancellationInvoiceId) !== -1;
  }

  public static getInvoice(order: Order): Invoice {
    return order?.invoices?.find((i) => !i.isArchived && !i.cancellationInvoiceId);
  }
}
